import type {ParserT} from '@freckle/parser'
import {Parser, string, number, record, nullable, stringEnum, array} from '@freckle/parser'
import type {IdentityProviderT} from '@freckle/educator-entities/ts/roster/identity-provider'
import {parser as identityProviderParser} from '@freckle/educator-entities/ts/roster/identity-provider'
import {RosterSources} from '@freckle/educator-entities/ts/users/logic/roster-source'
import type {RosterSourceT} from '@freckle/educator-entities/ts/users/logic/roster-source'

export type CourseSimplifiedT = {
  id: number
  name: string
}

export type TeacherSimplifiedT = {
  id: number
  name: string
}

export type StudentTableRowT = {
  id: number
  firstName: string
  lastName: string
  sisId: string | undefined | null
  grade: number
  source: RosterSourceT | undefined | null
  teacherIds: Array<number>
  coursesCount: number
  identityProvider: IdentityProviderT | undefined | null
}

function parse(response: unknown): StudentTableRowT {
  const attrs = record({
    id: number(),
    firstName: string(),
    lastName: string(),
    sisId: nullable(string()),
    grade: number(),
    source: nullable(stringEnum('RosterSourceT', RosterSources.parse)),
    teacherIds: array(number()),
    coursesCount: number(),
    identityProvider: nullable(identityProviderParser)
  }) as ParserT<StudentTableRowT>
  return Parser.run(response, attrs)
}

export function parseStudentTableRows(response: Array<unknown>): Array<StudentTableRowT> {
  return response.map(parse)
}
